import React from 'react';

const Notes = () => {
  return (
    <div style={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      gap: '12px',
      overflowY: 'auto',
      padding: '5px'
    }}>
      {/* Primary Sticky Note - Yellow */}
      <div style={{ 
        background: 'linear-gradient(135deg, #fff9c4 0%, #fff59d 100%)', 
        color: '#333', 
        padding: '15px', 
        borderRadius: '6px', 
        fontFamily: '"Segoe Print", "Comic Sans MS", cursive',
        boxShadow: '0 3px 8px rgba(0,0,0,0.15)',
        transform: 'rotate(-0.5deg)',
        border: '1px solid rgba(255, 235, 59, 0.3)'
      }}>
        <h3 style={{ 
          margin: '0 0 10px 0', 
          borderBottom: '2px solid #f9a825', 
          paddingBottom: '6px', 
          color: '#f57f17',
          fontSize: '14px',
          fontWeight: 'bold'
        }}>📌 TODO - URGENT</h3>
        <ul style={{ paddingLeft: '18px', margin: '8px 0', fontSize: '13px', lineHeight: '1.6' }}>
          <li>Backup server logs</li>
          <li><strong style={{ color: '#d32f2f' }}>Check robots.txt</strong> - ensure sensitive paths are disallowed!</li>
          <li>Buy more coffee ☕ (critical!)</li>
          <li>Fix the auth bug in prod 🔧</li>
        </ul>
      </div>

      {/* Secondary Note - Pink */}
      <div style={{ 
        background: 'linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%)', 
        color: '#333', 
        padding: '12px', 
        borderRadius: '6px', 
        fontFamily: '"Segoe Print", "Comic Sans MS", cursive',
        boxShadow: '0 3px 8px rgba(0,0,0,0.15)',
        transform: 'rotate(0.5deg)',
        border: '1px solid rgba(236, 64, 122, 0.2)',
        fontSize: '12px'
      }}>
        <h4 style={{ 
          margin: '0 0 8px 0', 
          color: '#c2185b',
          fontSize: '13px',
          fontWeight: 'bold'
        }}>💡 Reminder</h4>
        <p style={{ margin: '4px 0', lineHeight: '1.5' }}>
          Don't forget to update the CTF challenges before deployment. The hidden files are in <code style={{ background: 'rgba(0,0,0,0.1)', padding: '2px 4px', borderRadius: '3px' }}>/home/visitor</code>
        </p>
      </div>

      {/* Tertiary Note - Green */}
      <div style={{ 
        background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)', 
        color: '#333', 
        padding: '12px', 
        borderRadius: '6px', 
        fontFamily: '"Segoe Print", "Comic Sans MS", cursive',
        boxShadow: '0 3px 8px rgba(0,0,0,0.15)',
        transform: 'rotate(-0.3deg)',
        border: '1px solid rgba(76, 175, 80, 0.3)',
        fontSize: '12px'
      }}>
        <h4 style={{ 
          margin: '0 0 8px 0', 
          color: '#388e3c',
          fontSize: '13px',
          fontWeight: 'bold'
        }}>✅ Completed</h4>
        <ul style={{ paddingLeft: '18px', margin: '0', lineHeight: '1.5' }}>
          <li style={{ textDecoration: 'line-through', opacity: 0.7 }}>Deploy portfolio v2.0</li>
          <li style={{ textDecoration: 'line-through', opacity: 0.7 }}>Implement resume viewer</li>
          <li style={{ textDecoration: 'line-through', opacity: 0.7 }}>Test all CTF stages 🔍</li>
        </ul>
      </div>
    </div>
  );
};

export default Notes;
